export const colors = {
    darkBlue: "#182D86",
    spareBlue: "#4C6EF8",
    lightBlue: "#87A6EA",
    orange: "#FF5B3C",
    orangeLight: "#F69300",
    red: "#C42316",
    pink: "#FFDCD4",
    lightGray: "#DAD0C7",
    darkGray: "#666666",
    backgroundGray: "#e9e8e7a2",
    boxShadow: "rgba(0, 0, 0, 0.1)",
    white: "#ffffff",
    black: "#000000",
  };

  